import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "./ui/button";

function Layout({ children }) {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = React.useState(false);

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const purchasePages = [
    { path: "/", label: "Dashboard" },
    { path: "/purchase-dashboard", label: "Purchase Dashboard" },
    { path: "/requisitions", label: "Purchase Requests" },
    { path: "/tender-outcomes", label: "Tender Management" },
    { path: "/sanction-proposals", label: "Sanction Proposals" },
    { path: "/purchase-orders", label: "Purchase Orders" },
    { path: "/payments", label: "Payment Advice" },
    { path: "/grn", label: "GRN / Goods Received" },
    { path: "/vendors", label: "Vendors" },
    { path: "/approvals", label: "Approvals" },
  ];

  const hrPages = [
    { path: "/hr", label: "HR Dashboard" },
    { path: "/exam-entry/manage", label: "Manage Database" },
    { path: "/exam-entry/face-verify", label: "Examination Verification" },
    { path: "/hr/shortlist", label: "Shortlist Candidates" },
    { path: "/hr/interview", label: "Interview Schedule" },
    { path: "/hr/report", label: "Final Report" },
  ];

  const isHR = user?.role === "HR_RECRUIT";
  const isAdmin = user?.role === "ADMIN";
  const pages = isHR ? hrPages : isAdmin ? [...purchasePages, ...hrPages] : purchasePages;

  const currentPage = pages.find(p => p.path === location.pathname) || pages[0];

  return React.createElement("div", { className: "min-h-screen bg-slate-50 flex" },
    React.createElement("aside", { className: "hidden lg:flex w-64 min-h-screen bg-slate-900 text-slate-300 flex-col" },
      React.createElement("div", { className: "p-6 border-b border-slate-800" },
        React.createElement("h1", { className: "font-bold text-white text-lg" }, "Disha"),
        React.createElement("p", { className: "text-xs text-slate-400" }, "IIT Hyderabad")
      ),
      React.createElement("nav", { className: "p-4 space-y-1 flex-1" },
        pages.map(item => 
          React.createElement(Link, {
            key: item.path,
            to: item.path,
            className: `flex items-center gap-3 px-3 py-2 rounded-md text-sm transition-colors ${location.pathname === item.path ? 'bg-slate-800 text-white font-medium' : 'text-slate-300 hover:bg-slate-800 hover:text-white'}`,
            "data-testid": `nav-${item.path.replace('/', '') || 'dashboard'}`
          }, item.label)
        )
      )
    ),
    sidebarOpen && React.createElement("div", { 
      className: "fixed inset-0 z-50 lg:hidden", 
      onClick: () => setSidebarOpen(false) 
    },
      React.createElement("div", { className: "fixed inset-0 bg-black/50" }),
      React.createElement("aside", { 
        className: "fixed left-0 top-0 h-full w-72 bg-slate-900 text-slate-300 z-50 flex flex-col",
        onClick: e => e.stopPropagation()
      },
        React.createElement("div", { className: "p-4 border-b border-slate-800 flex items-center justify-between" },
          React.createElement("span", { className: "font-bold text-white" }, "Disha"),
          React.createElement(Button, { variant: "ghost", size: "sm", onClick: () => setSidebarOpen(false), className: "text-white" }, "×")
        ),
        React.createElement("nav", { className: "p-4 space-y-1 flex-1" },
          pages.map(item => 
            React.createElement(Link, {
              key: item.path,
              to: item.path,
              onClick: () => setSidebarOpen(false),
              className: `block px-3 py-2 rounded-md text-sm ${location.pathname === item.path ? 'bg-slate-800 text-white' : 'text-slate-300 hover:bg-slate-800'}`
            }, item.label)
          )
        )
      )
    ),
    React.createElement("div", { className: "flex-1 flex flex-col" },
      React.createElement("header", { className: "bg-white border-b border-slate-200 sticky top-0 z-10" },
        React.createElement("div", { className: "flex items-center justify-between px-4 lg:px-8 h-16" },
          React.createElement("div", { className: "flex items-center gap-4" },
            React.createElement(Button, { 
              variant: "ghost", 
              size: "sm", 
              className: "lg:hidden", 
              onClick: () => setSidebarOpen(true),
              "data-testid": "mobile-menu-btn"
            }, "☰"),
            React.createElement("h2", { className: "text-lg font-semibold text-slate-900" }, currentPage.label)
          ),
          React.createElement("div", { className: "flex items-center gap-4" },
            React.createElement("div", { className: "flex items-center gap-2" },
              React.createElement("div", { className: "w-8 h-8 bg-slate-900 rounded-full flex items-center justify-center text-white text-sm" }, user?.name?.charAt(0)),
              React.createElement("span", { className: "hidden md:block text-sm font-medium text-slate-900" }, user?.name)
            ),
            React.createElement(Button, { variant: "outline", size: "sm", onClick: handleLogout, "data-testid": "logout-btn" }, "Logout")
          )
        )
      ),
      React.createElement("main", { className: "flex-1 p-4 lg:p-8" }, children),
      React.createElement("footer", { className: "bg-white border-t border-slate-200 px-4 py-3" },
        React.createElement("p", { className: "text-xs text-slate-500 text-center" }, "© 2024 IIT Hyderabad")
      )
    )
  );
}

export default Layout;
